import React, { useState, useEffect } from "react";
import "./productDetails.css";
// import emailjs from "@emailjs/browser";
import { Link, useParams } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { productData } from "../../productData";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";

const ProductDetails = () => {

    const [showDescription, setShowDescription] = useState(true);

    const [selectedPack, setSelectedPack] = useState(1);

    const packOptions = [1, 3, 5, 10, 15];

    const [showModal, setShowModal] = useState(false);

    const [formData, setFormData] = useState({
        name: "",
        city: "",
        state: "",
        phone: "",
        message: "",
        pack: selectedPack,
    });

    useEffect(() => {
        setFormData(prev => ({
            ...prev,
            pack: selectedPack
        }));
    }, [selectedPack]);


    const { id } = useParams();

    const product = productData.find((i) => i.id === id);


    if (!product) return <p>Product not found!</p>;

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const sendEnquiry = (e) => {
        e.preventDefault();

        if (!formData.name || !formData.phone || !formData.city || !formData.state) {
            alert("Please fill all required fields");
            return;
        }

        toast.success("Enquiry Sent Successfully!");
        setShowModal(false);
        setFormData({
            name: "",
            city: "",
            state: "",
            phone: "",
            message: "",
        })


        // const templateParams = {
        //     product_name: productData.title,
        //     customer_name: formData.name,
        //     customer_city: formData.city,
        //     customer_state: formData.state,
        //     customer_phone: formData.phone,
        //     customer_message: formData.message,
        // };

        // emailjs
        //     .send(
        //         "service_en7eoep",
        //         "template_0ooualu",
        //         templateParams,
        //         "EwW3WLTvoF5mKxTkS"
        //     )
        //     .then(() => {
        //         alert("Enquiry Sent Successfully!");
        //         setShowModal(false);
        //         setFormData({
        //             name: "",
        //             city: "",
        //             state: "",
        //             phone: "",
        //             message: "",
        //         });
        //     })
        //     .catch((error) => {
        //         alert("Failed to send enquiry. Try again.");
        //         console.log(error);
        //     });
    };



    return (


        <>
            <div className='top-img bg'>
                {/* <img src={require("../../assets/packings-pills-capsules-medicines.jpg")} alt="" /> */}
                <div className="top-content">
                    <h1>{product.name}</h1>
                    <div className="top-link">
                        <div className='home-link'>  <Link to="/" >Home</Link> </div>
                        <div className='currentpage'>Product Details</div>
                    </div>

                </div>

            </div>

            <div className="pd-container" >
                <ToastContainer position="top-right" autoClose={4000} />
                <div className="pd-wrapper" >
                    <div className="pd-left">
                        <img src={require(`../../assets/product-img/${product.image}`)} alt={product.name} className="pd-image" />
                    </div>

                    <div className="pd-right">
                        <h2>{product.name}</h2>
                        {/* {product.specs && product.specs.length > 0 && (
                            <div className="pd-specs">
                                {product.specs.map((spec, index) => (
                                    <p key={index} className="pd-spec-item">
                                        <strong>{spec.label}</strong> : <span>{spec.value}</span>
                                    </p>
                                ))}
                            </div>
                        )} */}

                        {product.specs && product.specs.length > 0 && (
                            <div className="pd-specs">

                                {/* Normal specs except Pack of */}
                                {product.specs
                                    .filter(spec => spec.label !== "Pack of")
                                    .map((spec, index) => (
                                        <p key={index} className="pd-spec-item">
                                            <strong>{spec.label}</strong> : <span>{spec.value}</span>
                                        </p>
                                    ))}

                                {/* Pack selector ONLY for adult diapers */}
                                {product.category === "adult-diapers" && (
                                    <div className="pd-pack-selector">
                                        <div>
                                            <strong>Pack Of</strong> : <span>{selectedPack}</span>
                                        </div>
                                        
                                        <div className="pd-pack-options">
                                            {packOptions.map(pack => (
                                                <button
                                                    key={pack}
                                                    className={`pack-btn ${selectedPack === pack ? "active" : ""}`}
                                                    onClick={() => setSelectedPack(pack)}
                                                >
                                                    {pack}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}

                            </div>
                        )}


                        <button className="pd-btn" onClick={() => setShowModal(true)}>
                            Enquiry Now
                        </button>
                        {product.description && (
                            <div className="pd-desc-box">
                                <div
                                    className="pd-desc-header"
                                    onClick={() => setShowDescription(!showDescription)}
                                >
                                    <h4>Description</h4>
                                    {showDescription ? <IoIosArrowUp /> : <IoIosArrowDown />}
                                </div>

                                {showDescription && (
                                    <p className="pd-desc-text">{product.description}</p>
                                )}
                            </div>
                        )}


                    </div>
                </div>

                {/* Modal */}
                {showModal && (
                    <div className="pd-modal-overlay">
                        <div className="pd-modal">
                            <h3>Enquiry About {product.name} </h3>

                            {/* <p style={{ fontWeight: "600", marginBottom: "15px" }}>
                                Pack Of: <span style={{ color: "#1a1a3c" }}>{selectedPack}</span>
                            </p> */}


                            <form onSubmit={sendEnquiry}>
                                <input
                                    type="text"
                                    name="name"
                                    placeholder="Full Name *"
                                    value={formData.name}
                                    onChange={handleChange}
                                />
                                <input
                                    type="text"
                                    name="city"
                                    placeholder="City *"
                                    value={formData.city}
                                    onChange={handleChange}
                                />
                                <input
                                    type="text"
                                    name="state"
                                    placeholder="State *"
                                    value={formData.state}
                                    onChange={handleChange}
                                />
                                <input
                                    type="tel"
                                    name="phone"
                                    placeholder="Phone Number *"
                                    value={formData.phone}
                                    onChange={handleChange}
                                />
                                <textarea
                                    name="message"
                                    placeholder="Write message (optional)"
                                    value={formData.message}
                                    onChange={handleChange}
                                />

                                <div className="pd-modal-btns">
                                    <button type="button" className="cancel" onClick={() => setShowModal(false)}>
                                        Cancel
                                    </button>
                                    <button type="submit" className="send">
                                        Send Enquiry
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>

        </>

    );
};

export default ProductDetails;
